import styled from '@emotion/styled';
import { Box } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const QuestionSectionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 1500px;
  width: 100%;
  background-color: ${customPalette.accent.white};
  padding: 24px;
  border-radius: 8px;

  > h2 {
    margin-bottom: 8px;
  }
`;

export const QuestionContainer = styled(Box)<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 48px;

  > h3 {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
    color: ${(props) => (props.disabled ? customPalette.grey[400] : 'inherit')};
  }
`;

export const QuestionInputWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;

  > div:first-of-type {
    flex-grow: 1;
    min-width: 0;
  }

  > div:nth-of-type(2) {
    flex-shrink: 0;
  }

  > button {
    flex-shrink: 0;
    min-width: max-content;
    width: auto;
    align-self: center;
    white-space: nowrap;
    padding: 6px 16px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CheckboxWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QuestionRemoveButton = styled(Box)`
  display: flex;
  align-items: center;

  > button {
    min-width: max-content;
    width: auto;
    padding: 6px 16px;
    flex-shrink: 0;
  }
`;

export const ActionsContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${customPalette.grey[200]};

  > button {
    min-width: max-content;
  }
`;

export const AddQuestionButton = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;

  > button {
    width: 100%;
  }
`;

export const EditableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${customPalette.accent.white};
  padding: 32px;
  border-radius: 8px;

  > h3 {
    color: grey;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 16px 0;
  }
`;
